import React from 'react';
import { CheckIcon, ClipboardListIcon } from 'lucide-react';
import { toast } from 'sonner';
import { useHRStore } from '../../hooks/useHRStore';
import type { Navigate } from '../../types/hr';
import { displayName } from '../../utils/employees';
import { relativeDay } from '../../utils/format';
import { hrActions } from '../../utils/hrStore';
import { Avatar } from '../ui/Avatar';
import { Badge } from '../ui/Badge';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { EmptyState } from '../ui/EmptyState';
export function ChangeRequestsCard({
  onNavigate
}: {
  onNavigate: Navigate;
}) {
  const {
    changeRequests,
    employees
  } = useHRStore();
  const pending = changeRequests.filter(c => c.status === 'pending').length;
  return <Card title="Profile change requests" subtitle={pending ? `${pending} waiting for HR` : 'Submitted by employees from My Info'} icon={ClipboardListIcon} bodyClassName="px-3 pb-3" data-id="element-37" data-mp="1pmo5pwnz84fv">
      {changeRequests.length === 0 ? <div className="px-3 pb-3" data-id="element-38" data-mp="3pb58av6cw7q0">
          <EmptyState icon={ClipboardListIcon} title="No change requests" description="When employees ask HR to correct their info, it lands here." compact data-id="element-39" data-mp="3pa3mbvnsy0ti" />
        </div> : <ul className="divide-y divide-slate-100" data-id="element-40" data-mp="3g8w2gim192iy">
          {changeRequests.map(c => {
        const emp = employees.find(e => e.id === c.employeeId);
        if (!emp) return null;
        return <li key={c.id} className="flex flex-col gap-3 px-3 py-3.5 md:flex-row md:items-center" data-id="element-41" data-mp="36dc9a3yushxw">
                <button type="button" onClick={() => onNavigate({
            page: 'profile',
            employeeId: emp.id
          })} className="flex min-w-0 flex-1 items-center gap-3 text-left" data-id="element-42" data-mp="31jrgcqc4ae5k">
                  <Avatar name={displayName(emp)} seed={emp.id} data-id="element-43" data-mp="2slfj45gqwi45" />
                  <span className="min-w-0" data-id="element-44" data-mp="2nl06jg4afen8">
                    <span className="flex flex-wrap items-center gap-2 text-sm font-semibold text-navy" data-id="element-45" data-mp="2njykyhpnb9r9">
                      {displayName(emp)}
                      <Badge tone="navy" data-id="element-46" data-mp="28ykq0hwny8d1">
                        {c.section} · {c.field}
                      </Badge>
                    </span>
                    <span className="mt-0.5 block truncate text-xs text-slate-600" data-id="element-47" data-mp="2dygtmg1g7xs2">
                      “{c.current}” → <span className="font-medium text-navy" data-id="element-48" data-mp="1zz7nk96yik1t">“{c.requested}”</span>
                    </span>
                    {c.note && <span className="block truncate text-xs italic text-muted" data-id="element-49" data-mp="23zrkpcrj5nny">“{c.note}”</span>}
                  </span>
                </button>
                <div className="flex shrink-0 items-center gap-3 pl-[52px] md:pl-0" data-id="element-50" data-mp="2woos2ku7e01x">
                  <span className="text-xs text-muted" data-id="element-51" data-mp="2iwqsb0mdtgif">{relativeDay(c.submitted)}</span>
                  {c.status === 'pending' ? <Button size="sm" variant="primary" icon={CheckIcon} onClick={() => {
              hrActions.completeChangeRequest(c.id);
              toast.success('Marked as updated', {
                description: `${displayName(emp)} will see “Updated by HR”.`
              });
            }} data-id="element-52" data-mp="2mxanhyneaa1x">
                      Mark updated
                    </Button> : <Badge tone="green" dot data-id="element-53" data-mp="1dofti4unc2n2">
                      Updated
                    </Badge>}
                </div>
              </li>;
      })}
        </ul>}
    </Card>;
}